export const newsletterStateEnum = {
  NEW: 'NEW',
  PENDING: 'PENDING',
  SENT: 'SENT'
}
